<template>
  <div
    v-if="entry"
    class="avatar-portrait"
    :style="sliceStyle"
    :title="entry.id"
    role="img"
    :aria-label="ariaLabel"
  ></div>
</template>

<script setup>
import { computed } from "vue";
import avatars from "@/data/avatars.json";

const props = defineProps({
  avatarId: { type: String, default: "" },
  avatar: { type: Object, default: null },
  size: { type: [Number, String], default: 64 },
});

const entry = computed(() => {
  if (props.avatar) return props.avatar;
  if (!props.avatarId) return null;
  return avatars.find((a) => a.id === props.avatarId) || null;
});

const sizeCss = computed(() =>
  typeof props.size === "number" ? `${props.size}px` : props.size
);

const sliceStyle = computed(() => {
  if (!entry.value) return {};
  const { sheet, x, y } = entry.value;
  return {
    width: sizeCss.value,
    height: sizeCss.value,
    backgroundImage: `url(/assets/avatars/${sheet})`,
    backgroundSize: "300% 300%",
    backgroundPosition: `${x * 50}% ${y * 50}%`,
    backgroundRepeat: "no-repeat",
  };
});

const ariaLabel = computed(() => {
  if (!entry.value) return "Avatar";
  return `${entry.value.gender} avatar, ${entry.value.hair_color} hair`;
});
</script>

<style scoped>
.avatar-portrait {
  overflow: hidden;
  flex-shrink: 0;
  background-color: rgba(0, 0, 0, 0.35);
}
</style>
